import { useState, useEffect } from   'react';
import { useForm } from 'react-hook-form';
import apiService from '../../Auth/apiService';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';  
import { FaArrowAltCircleRight, } from 'react-icons/fa';
import { useAuth } from '../../Auth/AuthContext';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';

export default function Ppaginas(){
    const { token } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const [datos, setDatos] = useState([]);
    const [modulos, setModulos] = useState([]); 
    const { handleSubmit, register, setValue, formState: { errors }} = useForm();
    const [MuestraFormulario, setMuestraFormulario] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    
    const [filters, setFilters] = useState({
    id: '',
    pagina: '',
    nombre: '',
    modulo: '',
    descripcion: '',
    sessionforms: '',
    enabled: '',
    mostrarnombre: ''
    });

    const filteredDatos = (datos || []).filter(row => {
    return (
        (!filters.id || row.id?.toString().includes(filters.id)) &&
        (!filters.pagina || (row.ppaPagina || '').toString().toLowerCase().includes(filters.pagina.toLowerCase())) &&
        (!filters.nombre || (row.ppaNombrepag || '').toString().toLowerCase().includes(filters.nombre.toLowerCase())) &&
        (!filters.modulo || String(row.ppaModuloid) === String(filters.modulo)) &&
        (!filters.descripcion || (row.ppaDescripcion || '').toString().toLowerCase().includes(filters.descripcion.toLowerCase())) &&
        (filters.sessionforms === '' || String(row.ppaSessionforms) === String(filters.sessionforms)) &&
        (filters.enabled === '' || String(row.ppaEnabled) === String(Number(filters.enabled))) &&
        (filters.mostrarnombre === '' || String(row.ppaMostrarnombre) === String(Number(filters.mostrarnombre)))
    );
    });
    
    useEffect(() => {
        fetchData();
        fetchModulos();
    }, []);
    const fetchData = async () => {
        const url = '/parametros/listarppaginas';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setDatos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    const fetchModulos = async () => {
        const url = '/parametros/listarpaginamodulosactivo';
        try {
        setCargando(true);
        const response = await apiService.get(url, token);
        const result = await response.data;
        setModulos(result);
        } catch (error) {
        console.error('Error fetching data:', error);
        } finally {
        setCargando(false);
        }
    };
    function Editar (row){
        setMuestraFormulario(true);
        setValue('id', row.id);
        setValue('Nuevo', false);
        setValue('ppaPagina', row.ppaPagina);
        setValue('ppaNombrepag', row.ppaNombrepag);
        setValue('ppaModuloid', row.ppaModuloid);
        setValue('ppaDescripcion', row.ppaDescripcion);
        setValue('ppaSessionforms', row.ppaSessionforms);
        setValue('ppaEnabled', row.ppaEnabled);
        setValue('ppaMostrarnombre', row.ppaMostrarnombre);
    }
    const Nuevo = () =>  {
        setValue('id', 0);
        setValue('Nuevo', true);
        setValue('ppaPagina', '');
        setValue('ppaNombrepag', '');
        setValue('ppaModuloid', 0);
        setValue('ppaDescripcion', '');
        setValue('ppaSessionforms', 0);
        setValue('ppaEnabled', 1);
        setValue('ppaMostrarnombre', 0);
        setMuestraFormulario(true);
    }
    const onSubmit = async (data) => {
        setCargando(true);
        let url;
        url = '/parametros/guardarlistarppaginas';
        try {
            const response = await apiService.post(url, data, token);
            if(response.status === 200){
                Mensaje('Guardar', JSON.stringify(response.data));
                Nuevo();
            }
        } catch (error) {
            if(error.status === 422){
                Mensaje('Guardar', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Guardar', JSON.stringify(error.response.data));
            }
            console.error('Error fetching data:', error);
        } finally {
            setCargando(false);
            fetchData();
            ResetForm();
        }
    };
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    const ResetForm = () => {
        setValue('id', 0);
        setValue('Nuevo', true);
        setValue('ppaPagina', '');
        setValue('ppaNombrepag', '');
        setValue('ppaModuloid', 0);
        setValue('ppaDescripcion', '');
        setValue('ppaSessionforms', 0);
        setValue('ppaEnabled', 1);
        setValue('ppaMostrarnombre', 0);
        setMuestraFormulario(false);
    }
    return (
        <div className="content-wrapper">
            <SeccionPageHeader  
                title="Paginas"
                idCabezaFamilia="1"
                url="/parametros"
                nombreurl="Parámetros"
                nombreform=" Paginas"
            />
            <CargandoSpinner Cargando={Cargando}/>
            <section className="content">
                <div className="container-fluid">
                    {MuestraFormulario && <div className="card card">
                            <div className='card-header'>
                                <h3 className='card-title'>Formulario paginas</h3>
                            </div>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card-body">
                                    <input hidden {...register('id')}/>
                                    <input hidden {...register('Nuevo')}/>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="ppaPagina">P&aacute;gina</label>
                                                <input 
                                                    id="ppaPagina"
                                                    type="text" 
                                                    className="form-control" 
                                                    {...register('ppaPagina', { required: true })} 
                                                />
                                                {errors.ppaPagina && <span className="text-danger">Este campo es requerido</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="ppaNombrepag">Nombre P&aacute;gina</label>
                                                <input 
                                                    id="ppaNombrepag"
                                                    type="text" 
                                                    className="form-control" 
                                                    {...register('ppaNombrepag', { required: true })} 
                                                />
                                                {errors.ppaNombrepag && <span className="text-danger">Este campo es requerido</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="ppaModuloid">M&oacute;dulo</label>
                                                <select 
                                                    id="ppaModuloid"
                                                    className="form-control" 
                                                    {...register('ppaModuloid', { required: true })}
                                                >
                                                    <option value="">Seleccione</option>
                                                    {modulos.map(modulo => (
                                                        <option key={modulo.id} value={modulo.id}>{modulo.pmoNombre}</option>
                                                    ))}
                                                </select>
                                                {errors.ppaModuloid && <span className="text-danger">Este campo es requerido</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="ppaDescripcion">Descripci&oacute;n</label>
                                                <input 
                                                    id="ppaDescripcion"
                                                    type="text" 
                                                    className="form-control" 
                                                    {...register('ppaDescripcion', { required: true })} 
                                                />
                                                {errors.ppaDescripcion && <span className="text-danger">Este campo es requerido</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="ppaSessionforms">Session Forms</label>
                                                <select 
                                                    id="ppaSessionforms"
                                                    className="form-control" 
                                                    {...register('ppaSessionforms', { required: true })}
                                                >
                                                    <option value="0">No</option>
                                                    <option value="1">S&iacute;</option>
                                                </select>
                                                {errors.ppaSessionforms && <span className="text-danger">Este campo es requerido</span>}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="ppaEnabled">Habilitado</label>
                                                <select 
                                                    id="ppaEnabled"
                                                    className="form-control" 
                                                    {...register('ppaEnabled', { required: true })}
                                                >
                                                    <option value="0">No</option>
                                                    <option value="1">S&iacute;</option>
                                                </select>
                                                {errors.ppaEnabled && <span className="text-danger">Este campo es requerido</span>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label htmlFor="ppaMostrarnombre">Mostrar Nombre</label>
                                                <select 
                                                    id="ppaMostrarnombre"
                                                    className="form-control" 
                                                    {...register('ppaMostrarnombre', { required: true })}
                                                >
                                                    <option value="0">No</option>
                                                    <option value="1">S&iacute;</option>
                                                </select>
                                                {errors.ppaMostrarnombre && <span className="text-danger">Este campo es requerido</span>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <div className='row'>
                                        <div className='col-md-1'>
                                            <button type="submit" className="btn btn-info">Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    }   
                    <div className="card card">
                        <div className="card-body">
                            <div className="card-body table-responsive p-0">
                                <div className='row'>
                                    <div className='col-md-2'>
                                        <button type="button" className='form-control' onClick={Nuevo}>Nuevo</button>
                                    </div>
                                </div>
                                <div className="mt-3">
                                    <div className="row mb-2">
                                        <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Id"
                                            value={filters.id}
                                            onChange={e => setFilters(f => ({ ...f, id: e.target.value }))}
                                        />
                                        </div>
                                        <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Página"
                                            value={filters.pagina}
                                            onChange={e => setFilters(f => ({ ...f, pagina: e.target.value }))}
                                        />
                                        </div>
                                        <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Nombre"
                                            value={filters.nombre}
                                            onChange={e => setFilters(f => ({ ...f, nombre: e.target.value }))}
                                        />
                                        </div>
                                        <div className="col-md-2">
                                        <select
                                            className="form-control"
                                            value={filters.modulo}
                                            onChange={e => setFilters(f => ({ ...f, modulo: e.target.value }))}
                                        >
                                            <option value="">Todos módulos</option>
                                            {modulos.map(m => <option key={m.id} value={m.id}>{m.pmoNombre}</option>)}
                                        </select>
                                        </div>
                                        <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Descripción"
                                            value={filters.descripcion}
                                            onChange={e => setFilters(f => ({ ...f, descripcion: e.target.value }))}
                                        />
                                        </div>
                                        <div className="col-md-1">
                                        <button className="btn btn-secondary" onClick={() => setFilters({
                                            id: '', pagina: '', nombre: '', modulo: '', descripcion: '',
                                            sessionforms: '', enabled: '', mostrarnombre: ''
                                        })}>Limpiar</button>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover table-sm">
                                        <thead>
                                            <tr>
                                            <th style={{width: '7%'}}>Acciones</th>
                                            <th style={{width: '7%'}}>Id</th>
                                            <th style={{width: '15%'}}>Página</th>
                                            <th style={{width: '20%'}}>Nombre Página</th>
                                            <th style={{width: '10%'}}>Módulo Id</th>
                                            <th style={{width: '25%'}}>Descripción</th>
                                            <th style={{width: '8%'}}>Session Forms</th>
                                            <th style={{width: '8%'}}>Habilitado</th>
                                            <th style={{width: '8%'}}>Mostrar Nombre</th>
                                            </tr>
                                            <tr>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th></th>
                                            <th>
                                                <select
                                                className="form-control form-control-sm"
                                                value={filters.sessionforms}
                                                onChange={e => setFilters(f => ({ ...f, sessionforms: e.target.value }))}
                                                >
                                                <option value="">Todos</option>
                                                <option value="1">Sí</option>
                                                <option value="0">No</option>
                                                </select>
                                            </th>
                                            <th>
                                                <select
                                                className="form-control form-control-sm"
                                                value={filters.enabled}
                                                onChange={e => setFilters(f => ({ ...f, enabled: e.target.value }))}
                                                >
                                                <option value="">Todos</option>
                                                <option value="1">Habilitado</option>
                                                <option value="0">No</option>
                                                </select>
                                            </th>
                                            <th>
                                                <select
                                                className="form-control form-control-sm"
                                                value={filters.mostrarnombre}
                                                onChange={e => setFilters(f => ({ ...f, mostrarnombre: e.target.value }))}
                                                >
                                                <option value="">Todos</option>
                                                <option value="1">Sí</option>
                                                <option value="0">No</option>
                                                </select>
                                            </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Cargando ? (
                                            <tr><td colSpan={9} className="text-center">Cargando...</td></tr>
                                            ) : filteredDatos.length === 0 ? (
                                            <tr><td colSpan={9} className="text-center">No hay datos para mostrar</td></tr>
                                            ) : (
                                            filteredDatos.map(row => (
                                                <tr key={row.id}>
                                                <td>
                                                    <div className="btn-group">
                                                    <button type="button" className="btn btn-info" onClick={() => Editar(row)}
                                                        data-tooltip-id='tooltiparriba'
                                                        data-tooltip-content="Editar">
                                                        <FaArrowAltCircleRight/>
                                                    </button>
                                                    </div>
                                                </td>
                                                <td>{row.id}</td>
                                                <td>{row.ppaPagina}</td>
                                                <td>{row.ppaNombrepag}</td>
                                                <td>{row.ppaModuloid}</td>
                                                <td>{row.ppaDescripcion}</td>
                                                <td>{row.ppaSessionforms}</td>
                                                <td>{row.ppaEnabled === 1 ? 'SI' : 'NO'}</td>
                                                <td>{row.ppaMostrarnombre === 1 ? 'SI' : 'NO'}</td>
                                                </tr>
                                            ))
                                            )}
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
            <Tooltip id="tooltiparriba" place="right"/>
        </div>
    );
}